import { render, staticRenderFns } from "./Observation.vue?vue&type=template&id=925a711c&scoped=true&"
import script from "./Observation.vue?vue&type=script&lang=js&"
export * from "./Observation.vue?vue&type=script&lang=js&"
import style0 from "./Observation.vue?vue&type=style&index=0&id=925a711c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925a711c",
  null
  
)

export default component.exports